import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectIsMini } from '@shared/api/reduxToolkit';
import { ChevronLeftIcon, ChevronRightIcon } from '@shared/assets/icons';
import { i18TranslationNS, Translation } from '@shared/config/i18n';

import s from './CollapseMenuButton.module.css';

/**
 * Отображает кнопку сворачивания/разворачивания сайдбара.
 * В свёрнутом состоянии показывает иконку ChevronRight (действие: развернуть),
 * в развёрнутом — ChevronLeft (действие: свернуть).
 *
 * @param {Object} props - Свойства компонента
 * @param {() => void} props.onToggle - Функция, вызываемая при клике на кнопку
 * @param {string} [props.controlsId='sidebar'] - ID элемента, которым управляет кнопка (для доступности)
 * @param {string} [props.className] - Дополнительный CSS-класс для стилизации
 *
 * @example
 * <CollapseMenuButton onToggle={handleToggle} controlsId="aside" />
 */
export const CollapseMenuButton = ({ onToggle, controlsId = 'sidebar', className }) => {
	const isMini = useSelector(selectIsMini);
	const { t } = useTranslation(i18TranslationNS);

	// isMini = true → sidebar is collapsed → show ChevronRight (action: expand)
	// isMini = false → sidebar is expanded → show ChevronLeft (action: collapse)
	const Icon = isMini ? ChevronRightIcon : ChevronLeftIcon;

	return (
		<button
			className={clsx(s.collapseMenuButton, className)}
			onClick={onToggle}
			aria-label={isMini ? t(Translation.COLLAPSEMENUBUTTON_ARIA_EXPAND) : t(Translation.COLLAPSEMENUBUTTON_ARIA_COLLAPSE)}
			aria-expanded={!isMini}
			aria-controls={controlsId}
			type='button'
		>
			<Icon className={s.collapseMenuButton_icon} aria-hidden='true' focusable='false' />
		</button>
	);
};
